import { Component, OnInit } from '@angular/core';
import { LoginService } from '@app/services/login.service';

@Component({
  selector: 'app-administrativo-clientes-lista',
  templateUrl: './administrativo-clientes-lista.component.html',
  styleUrls: ['./administrativo-clientes-lista.component.scss']
})
export class AdministrativoClientesListaComponent implements OnInit {
  listaClientes: Cliente[] = [];
  exclusaoLiberada: boolean = false;

  constructor(private _loginService: LoginService) { }

  ngOnInit(): void {
    this.obterClientes();
  }

  obterClientes() {
    this._loginService.obterClientes().subscribe(
      (data: any) => {
        this.listaClientes = data;
      }
    );
  }
  
  controlaExclusao() {
    if (this.exclusaoLiberada) {
      this._bloqueiaExclusao();
      return;
    }
    if (!this.exclusaoLiberada) {
      this._liberaExclusao();
      return;
    }
  }

  private _liberaExclusao() {
    this.exclusaoLiberada = true;
  }
  
  private _bloqueiaExclusao() {
    this.exclusaoLiberada = false;
  }

  excluirCliente(idCliente: number): void {
    if(!this.exclusaoLiberada) {
      alert('Exclusão não liberada');
      return;
    }
    this._loginService.excluirCliente(idCliente).subscribe(
      (data: any) => {
        this.listaClientes = data;
      }
    );
  }
}

export class Cliente {
  public Id: number;
  public DB: string;
  //public StorageName: string;
  public StorageKey: string;
  public StorageId: string;
  public VersaoAtual: number;
  public VersaoAnterior: number;
  public Nome: string;
  public DataCadastro: Date;
}
